export const commonDownloadPdf = function (res, fileName, noDateTimeStampRequired) {
    var date = new Date(),
        dateformat = [date.getDate(),
        date.getMonth() + 1,
        date.getFullYear(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
        ].join('-');
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
        window.navigator.msSaveOrOpenBlob(new Blob([res]), fileName + "_" + dateformat + ".pdf");
    } else {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        if (noDateTimeStampRequired) {
            link.setAttribute('download', fileName + ".pdf");
        }
        else {
            link.setAttribute('download', fileName + "_" + dateformat + ".pdf");
        }
        document.body.appendChild(link);
        link.click();
    }

}
